import React from 'react';
import Select from "react-select";

const serialNumberSeparators = [', ', '; ', ',', ';', ' ', '/n'];

/**
 * Bulk update card readers or SIM cards
 * this.props.isSimUpdate will be true if we are updating SIM cards, else false
 */
class BulkUpdateReaderTrackingDataPage extends waffle.base.BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            movementDate: moment(),
            serialNumbers: [''], // SIM numbers in case of SIMs
            fulfilmentState: undefined,
            location: undefined,
            readerStatus: undefined,
            fulfilmentStates: [],
            locations: [],
            readerStatuses: [],
            comment: '',

        }
    }

    componentWillMount() {
        this.loadValidReaderAttributes()
    }

    setMovementDate(newMoment) {
        const newMovementDate = isNaN(newMoment) ? moment() : newMoment;
        this.setState({
            movementDate: newMovementDate
        })
    }

    updateSerialNumberRow(input, index) {
        const serialNumbers = this.inputToSerialNumbers(input);
        const newSerialNumbers = this.state.serialNumbers;
        for (const sn of serialNumbers) {
            newSerialNumbers[index] = sn;
            index++
        }
        if (serialNumbers.length > 0 && newSerialNumbers.length > 0 && newSerialNumbers[newSerialNumbers.length - 1] !== '') {
            this.setState({
                serialNumbers: [...newSerialNumbers, '']
            })
        } else {
            this.setState({
                serialNumbers: newSerialNumbers
            })
        }
    }

    // A user can paste a whole column from a google sheet or an excel document.
    // We attempt to split the input on various separators until we have more
    // than 1 serial number or we run out of separators.
    inputToSerialNumbers(input, separatorIndex = 0) {
        if (separatorIndex > serialNumberSeparators.length - 1) {
            return [input]
        }
        const separator = serialNumberSeparators[separatorIndex];
        const serialNumbers = input.split(separator);
        if (serialNumbers.length === 1) {
            return this.inputToSerialNumbers(input, separatorIndex + 1)
        }
        return serialNumbers
    }

    removeSerialNumberRow(index) {
        const newSerialNumbers = this.state.serialNumbers;
        newSerialNumbers.splice(index, 1);
        this.setState({serialNumbers: newSerialNumbers})
    }

    serialNumberRow(serialNumber, index) {
        const key = "row-" + index;
        return (
            <div key={key}>
                <input
                    id={key}
                    value={serialNumber}
                    onChange={(event) => this.updateSerialNumberRow(event.target.value, index)}
                    placeholder={this.props.isSimUpdate ? 'Enter ICCID' : 'Enter serial number'}
                    className='serialNumberInput'
                />
                {!(index === this.state.serialNumbers.length - 1 && this.state.serialNumbers[index] === '') ?
                    <span title='Remove Row' className='removeSerialNumberRowButton' onClick={() => this.removeSerialNumberRow(index)}> <i
                        className={"fa fa-times fa-lg"}/></span>
                    : ''}
            </div>
        )
    }

    clearSerialNumbers() {
        this.setState({
            serialNumbers: ['']
        })
    }

    getSerialNumbersTable() {
        const infoTitle = `You may paste a whole list of ${this.props.isSimUpdate ? "ICCIDs" : "serial numbers"} at once`
        const clearTitle = `Clear ${this.props.isSimUpdate ? "ICCIDs" : "Serial Numbers"}`
        return (
            <div>
                <p>{this.state.serialNumbers.filter(sn => sn !== '').length} {this.props.isSimUpdate ? "ICCIDs" : "serial numbers"}</p>
                <div className='cardReaderSerialNumbersContainer'>
                    <div className='cardReaderSerialNumbersTable'>
                        <div>
                            {this.state.serialNumbers.map((serialNumber, index) => this.serialNumberRow(serialNumber, index))}
                        </div>
                    </div>
                    <div className='serialNumbersSideIcons'>
              <span title={infoTitle}>
                <i className={"fa fa-info-circle"}/>
              </span>
                        <span
                            className='iconButton'
                            title={clearTitle}
                            onClick={this.clearSerialNumbers.bind(this)}>
              <i className={"fa fa-trash fa-2x"}/>
            </span>
                    </div>
                </div>
            </div>
        )
    }

    loadValidReaderAttributes(params='') {
        $.ajax({
            url: `/api/readers/validReaderAttributes/${params}`,
            method: 'GET'
        }).done((response) => {
            if (response.status === 200) {
                this.setState({
                    fulfilmentStates: response.data.readerFulfilmentStates.sort().map(state => { return {value: state, label: state.humanize()} }),
                    locations: response.data.readerLocations.sort().map(location => { return {value: location, label: location.humanize()} }),
                    readerStatuses: response.data.readerStatuses.sort().map(status => { return {value: status, label: status.humanize()} })
                })
            } else {
                radio('showAlert').broadcast('danger', `${response.message} (${response.status})`)
            }
        }).fail((_, textStatus) => {
            radio('showAlert').broadcast('danger', textStatus)
        })
    }

    bulkUpdateReaderAttributes() {
        const url = this.props.isSimUpdate ? '/api/simCards/bulkUpdate' : '/api/readers/bulkUpdateReaderAttributes'
        const serialNumbers = this.state.serialNumbers.filter(sn => sn !== '');
        if (serialNumbers.length === 0) {
            radio('showAlert').broadcast('danger', `Please enter at least 1 ${this.props.isSimUpdate ? 'ICCID' : 'serial number'}.`)
        } else if (serialNumbers.length > 10000) {
            radio('showAlert').broadcast('danger', 'Too many rows. You may only do 10000 updates at a time.')
        } else if (!this.state.fulfilmentState) {
            radio('showAlert').broadcast('danger', 'Please select a fulfilment state')
        } else if (!this.state.location) {
            radio('showAlert').broadcast('danger', 'Please select a location')
        } else if (!this.props.isSimUpdate && !this.state.readerStatus) {
            radio('showAlert').broadcast('danger', 'Please select a reader status')
        } else {
            radio('showLoader').broadcast();
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: this.props.isSimUpdate ? this.buildSimUpdatePayload(serialNumbers) : this.buildReaderUpdatePayload(serialNumbers)
            }).done((response) => {
                radio('hideLoader').broadcast();
                if (response.status === 200) {
                    radio('showAlert').broadcast('success', `${response.message || 'Success'}`)
                } else {
                    radio('showAlert').broadcast('danger', `${response.message}`)
                }
            }).fail((_, textStatus) => {
                radio('hideLoader').broadcast();
                radio('showAlert').broadcast('danger', textStatus)
            })
        }
    }

    buildReaderUpdatePayload(serialNumbers) {
        return JSON.stringify({
            movementDate: this.state.movementDate.format('YYYY-MM-DD'),
            serialNumbers: serialNumbers,
            readerStatus: this.state.readerStatus,
            readerFulfilmentState: this.state.fulfilmentState,
            readerLocation: this.state.location,
            comment: this.state.comment
        })
    }

    buildSimUpdatePayload(serialNumbers) {
        return JSON.stringify({
            movementDate: this.state.movementDate.format('YYYY-MM-DD'),
            simNumbers: serialNumbers,
            fulfilmentState: this.state.fulfilmentState,
            location: this.state.location
        })
    }

    resetReaderTrackingData() {
        this.setState({
            fulfilmentState: undefined,
            location: undefined,
            readerStatus: undefined
        });
        this.loadValidReaderAttributes()
    }

    getValidReaderAttributesSearchParameters() {
        let params = {
            readerStatus: this.state.readerStatus,
            readerLocation: this.state.location,
            readerFulfilmentState: this.state.fulfilmentState
        };
        let searchParameters = Object.keys(params).filter(k => params[k] !== '');
        if (searchParameters.length > 0){
            return `?${searchParameters.map(k => k + '=' + params[k]).join('&')}`
        }
        return ''
    }

    onReaderAttributeChange (data, property) {
        this.setState({
            [property]: data.value,
        },() => this.loadValidReaderAttributes(this.getValidReaderAttributesSearchParameters()))
    }

    getReaderTrackingDataRows() {
        return (
            <div className='cardReadersTrackingDataEditContainer'>
                <div className='cardReadersEditRows'>
                    <DetailsEditRow
                        text='Fulfilment State:'
                        value={this.state.fulfilmentState}
                        options={this.state.fulfilmentStates}
                        onChange={data => this.onReaderAttributeChange(data, 'fulfilmentState')}
                    />
                    <DetailsEditRow
                        text='Location:'
                        value={this.state.location}
                        options={this.state.locations}
                        onChange={data => this.onReaderAttributeChange(data, 'location')}
                    />
                    {this.props.isSimUpdate ? '' :
                        <DetailsEditRow
                        text='Reader Status:'
                        value={this.state.readerStatus}
                        options={this.state.readerStatuses}
                        onChange={data => this.onReaderAttributeChange(data, 'readerStatus')}
                        />
                    }
                </div>
                <div className='cardReadersEditRowsReset'>
                    <button
                        type="button"
                        className='btn-warning cardReadersNormalButton'
                        onClick={() => this.resetReaderTrackingData()}
                    >
                        Reset
                    </button>
                </div>
            </div>
        )
    }

    updateComment(evt){
        this.setState({
            comment: evt.target.value
        });
    }

    render() {
        return (
            <div className='cardReadersMainContainer'>
                <header className='cardReadersHeader'>
                    <h1>
                        {this.props.isSimUpdate ? 'Update SIM Cards' : 'Update Readers'}
                    </h1>
                </header>
                <div className='cardReadersDetailsContainer'>
                    <DetailsSubContainer
                        heading="Movement Date"
                        rows={
                            <waffle.misc.CalendarButton
                                date={this.state.movementDate}
                                dateChanged={this.setMovementDate.bind(this)}
                            />
                        }
                    />
                    <DetailsSubContainer
                        heading={this.props.isSimUpdate ? 'ICCIDs' : 'Serial Numbers'}
                        rows={this.getSerialNumbersTable()}
                    />
                        <DetailsSubContainer heading={`${this.props.isSimUpdate ? 'SIM' : 'Reader'} Tracking Data`}
                                             rows={this.getReaderTrackingDataRows()}/>
                    {this.props.isSimUpdate ? '' :
                        <DetailsSubContainer
                            heading="Comment"
                            rows={
                                <input
                                    value = {this.state.comment} onChange={evt => this.updateComment(evt)}
                                />
                            }
                        />
                    }
                </div>
                <div className='trackingDataSaveButtons'>
                    <button
                        type="button"
                        onClick={this.bulkUpdateReaderAttributes.bind(this)}
                        className='btn-primary cardReadersNormalButton'>
                        Save
                    </button>
                </div>
            </div>
        )
    }
}

/**
 * Bulk update to convert card readers to bundles
 */
class BulkReaderBundleConversionPage extends waffle.base.BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            serialNumbers: [''],
            bundle: undefined,
            bundles: [],

        }
    }

    componentWillMount() {
        this.loadValidReaderBundles()
    }

    updateSerialNumberRow(input, index) {
        const serialNumbers = this.inputToSerialNumbers(input);
        const newSerialNumbers = this.state.serialNumbers;
        for (const sn of serialNumbers) {
            newSerialNumbers[index] = sn;
            index++
        }
        if (serialNumbers.length > 0 && newSerialNumbers.length > 0 && newSerialNumbers[newSerialNumbers.length - 1] !== '') {
            this.setState({
                serialNumbers: [...newSerialNumbers, '']
            })
        } else {
            this.setState({
                serialNumbers: newSerialNumbers
            })
        }
    }

    // A user can paste a whole column from a google sheet or an excel document.
    // We attempt to split the input on various separators until we have more
    // than 1 serial number or we run out of separators.
    inputToSerialNumbers(input, separatorIndex = 0) {
        if (separatorIndex > serialNumberSeparators.length - 1) {
            return [input]
        }
        const separator = serialNumberSeparators[separatorIndex];
        const serialNumbers = input.split(separator);
        if (serialNumbers.length === 1) {
            return this.inputToSerialNumbers(input, separatorIndex + 1)
        }
        return serialNumbers
    }

    removeSerialNumberRow(index) {
        const newSerialNumbers = this.state.serialNumbers;
        newSerialNumbers.splice(index, 1);
        this.setState({serialNumbers: newSerialNumbers})
    }

    serialNumberRow(serialNumber, index) {
        const key = "row-" + index;
        return (
            <div key={key}>
                <input
                    id={key}
                    value={serialNumber}
                    onChange={(event) => this.updateSerialNumberRow(event.target.value, index)}
                    placeholder={'Enter serial number'}
                    className='serialNumberInput'
                />
                {!(index === this.state.serialNumbers.length - 1 && this.state.serialNumbers[index] === '') ?
                    <span title='Remove Row' className='removeSerialNumberRowButton' onClick={() => this.removeSerialNumberRow(index)}> <i
                        className={"fa fa-times fa-lg"}/></span>
                    : ''}
            </div>
        )
    }

    clearSerialNumbers() {
        this.setState({
            serialNumbers: ['']
        })
    }

    getSerialNumbersTable() {
        const infoTitle = `You may paste a whole list of serial numbers at once`
        const clearTitle = `Clear Serial Numbers`
        return (
            <div>
                <p>{this.state.serialNumbers.filter(sn => sn !== '').length} {"serial numbers"}</p>
                <div className='cardReaderSerialNumbersContainer'>
                    <div className='cardReaderSerialNumbersTable'>
                        <div>
                            {this.state.serialNumbers.map((serialNumber, index) => this.serialNumberRow(serialNumber, index))}
                        </div>
                    </div>
                    <div className='serialNumbersSideIcons'>
              <span title={infoTitle}>
                <i className={"fa fa-info-circle"}/>
              </span>
                        <span
                            className='iconButton'
                            title={clearTitle}
                            onClick={this.clearSerialNumbers.bind(this)}>
              <i className={"fa fa-trash fa-2x"}/>
            </span>
                    </div>
                </div>
            </div>
        )
    }

    loadValidReaderBundles(params='') {
        $.ajax({
            url: `/api/readerProducts/getBundleProducts`,
            method: 'GET'
        }).done((response) => {
            if (response.status === 200) {
                let sortedBundles = response.data.bundles.sort()
                this.setState({
                    bundles: sortedBundles.map(state => { return {value: state[0], label: state[1]} }),
                    bundle: sortedBundles[0][0]
                })
            } else {
                radio('showAlert').broadcast('danger', `${response.message} (${response.status})`)
            }
        }).fail((_, textStatus) => {
            radio('showAlert').broadcast('danger', textStatus)
        })
    }

    bulkConvertReaderToBundle() {
        const url = '/api/readers/convertToBundle'
        const serialNumbers = this.state.serialNumbers.filter(sn => sn !== '');
        if (serialNumbers.length === 0) {
            radio('showAlert').broadcast('danger', `Please enter at least 1 ${'serial number'}.`)
        } else if (serialNumbers.length > 10000) {
            radio('showAlert').broadcast('danger', 'Too many rows. You may only do 10000 updates at a time.')
        } else if (!this.state.bundle) {
            radio('showAlert').broadcast('danger', 'Please select a bundle')
        } else {
            radio('showLoader').broadcast();
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: this.buildReaderConversionPayload(serialNumbers)
            }).done((response) => {
                radio('hideLoader').broadcast();
                if (response.status === 200) {
                    radio('showAlert').broadcast('success', `${response.message || 'Success'}`)
                } else {
                    radio('showAlert').broadcast('danger', `${response.message}`)
                }
            }).fail((_, textStatus) => {
                radio('hideLoader').broadcast();
                radio('showAlert').broadcast('danger', textStatus)
            })
        }
    }

    buildReaderConversionPayload(serialNumbers) {
        return JSON.stringify({
            serialNumbers: serialNumbers,
            readerProductUUID: this.state.bundle,
        })
    }

    onBundleChange (data) {
        this.setState({
            bundle: data.value,
        })
    }

    getReaderConversionBundles() {
        let value = this.state.bundle ? this.state.bundle : ''
        return (
            <div className='cardReadersTrackingDataEditContainer'>
                <div className='cardReadersEditRows'>
                    <DetailsSelectRow
                        value={value}
                        options={this.state.bundles}
                        onChange={data => this.onBundleChange(data)}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className='cardReadersMainContainer'>
                <header className='cardReadersHeader'>
                    <h1>
                        {'Bulk update to bundle'}
                    </h1>
                </header>
                <div className='cardReadersDetailsContainer'>
                    <DetailsSubContainer heading={`Bundle`}
                                         rows={this.getReaderConversionBundles()}
                    />
                    <DetailsSubContainer
                        heading={'Serial Numbers'}
                        rows={this.getSerialNumbersTable()}
                    />
                </div>
                <div className='trackingDataSaveButtons'>
                    <button
                        type="button"
                        onClick={this.bulkConvertReaderToBundle.bind(this)}
                        className='btn-primary cardReadersNormalButton'>
                        Save
                    </button>
                </div>
            </div>
        )
    }
}

const DetailsSubContainer = ({heading,rows}) => (
    <div className='cardReadersDetailsSubContainer'>
        <header className='cardReadersDetailsSubContainerHeader'>
            <h2 className='cardReadersDetailsSubHeading'>
                {heading}
            </h2>
        </header>
        {rows}
    </div>
);

const DetailsEditRow = ({text, value, options, onChange, size = 200}) => (
    <div className='cardReadersDetailsRow'>
        <div className='cardReadersDetailsDescription'>
            {text}
        </div>
        <Select
            styles={{control: (base) => ({...base, width: `${size}px`})}}
            onChange={onChange}
            options={options}
            value={options.filter(option => option.value === value)}
            placeholder={'Select an option...'}
            isSearchable={false}
            isClearable={false}
            // // Workaround for bug https://github.com/JedWatson/react-select/issues/439
            cacheAsyncResults={false}
        />
    </div>
);

const DetailsSelectRow = ({value, options, onChange, size = 200}) => (
    <div className='cardReadersDetailsRow'>
        <Select
            styles={{control: (base) => ({...base, width: `${size}px`})}}
            onChange={onChange}
            options={options}
            value={options.filter(option => option.value === value)}
            placeholder={'Select an option...'}
            isSearchable={false}
            isClearable={false}
            // // Workaround for bug https://github.com/JedWatson/react-select/issues/439
            cacheAsyncResults={false}
        />
    </div>
);

module.exports = {
    BulkUpdateReaderTrackingDataPage,
    BulkReaderBundleConversionPage
};
